import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../queryKeys';
import { getTenantSmsPacing } from 'services/api/AccessManagerAPI';

// The tenant's SMS daily cap, super admin only. tenantId falsy holds the
// request back, so the editor can skip the fetch until a tenant is picked.
export const useGetTenantSmsPacing = (tenantId?: string) => {
    const { data, isLoading, ...rest } = useQuery({
        queryKey: queryKeys.tenantSmsPacing(tenantId ?? ''),
        queryFn: () => getTenantSmsPacing(tenantId as string),
        enabled: !!tenantId,
    });

    return { tenantSmsPacing: data, isTenantSmsPacingLoading: isLoading, ...rest };
};
